import { CONTRACT_BASE_URL } from "../../../constants";

export const AUTO_CASHOUT_BASE_URL = `${CONTRACT_BASE_URL}auto-cashout/api/auto-cashout`;

export const PAYMENT_CALLS_URL = (domainId: string) =>
  `${AUTO_CASHOUT_BASE_URL}/payment-calls/${domainId}`;
